import types from './types';

export const doLogin = () => ({
  type: types.DO_LOGIN
});

export const doLogout = () => ({
  type: types.DO_LOGOUT
});

export const setInitInfo = initInfo => ({
  type: types.SET_INIT_INFO,
  initInfo
});

export default {
  doLogin,
  doLogout,
  setInitInfo
};
